<script>
  /**
 *
 *
 *
 *
 */

  /*                */
  let { image, description, isBundle = false } = $props();

  const IMAGE_PRESET = '$tile_square$';

  const imageSrc = image._links?.external?.href + '?' + IMAGE_PRESET;

  const isBundleClass = isBundle ? '__bundle' : '';
</script>

<div class="reco_aos__image{isBundleClass} reco_aos__image__container">
  <div class="reco_aos__image__spinner_box{isBundleClass} p_loader250"></div>

  <picture>
    <source type="image/webp" srcset="{imageSrc}&fmt=webp" />
    <source type="image/jpeg" srcset={imageSrc} />
    <img
      class="reco_aos__image{isBundleClass} reco_aos_product_card__image"
      data-src={imageSrc}
      src={imageSrc}
      alt={description} />
  </picture>
</div>

<style lang="scss">
  .reco_aos__image {
    @media (min-width: 28em) {
      width: 80px;
    }
    @media (min-width: 48em) {
      width: 54px;
    }
    @media (min-width: 62em) {
      width: 80px;
    }
    width: 70px;
  }

  .reco_aos__image__bundle {
    width: 60px;
    height: 60px;
  }

  .reco_aos__image__container {
    position: relative;
    margin: 0 16px 0 0;
  }

  .reco_aos_product_card__image {
    height: auto;
    position: relative;
    z-index: 1;
  }

  .reco_aos__image__spinner_box {
    position: absolute;
    z-index: 0;

    @media (min-width: 28em) {
      width: 60px;
      height: 60px;
    }
    @media (min-width: 48em) {
      width: 40px;
      height: 40px;
      margin: 10px 0 0 7px;
    }
    @media (min-width: 62em) {
      width: 60px;
      height: 60px;
    }
    width: 52px;
    height: 52px;
    margin: 10px 0 0 10px;
  }

  .reco_aos__image__spinner_box__bundle {
    position: absolute;
    z-index: 0;

    width: 40px;
    height: 40px;
    margin: 20px 0 0 20px;
  }
</style>
